module.exports = __webpack_public_path__ + "assets/img/title-305403ef.png";